/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './DeleteIcon.scss'
import React, { Component } from 'react'
import Button from '../button/Button'
import Icon from './Icon'

class DeleteIcon extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      isDialogClosed: true
    }
  }

  onShowDialog() {
    const state = Object.assign({}, this.state)
    state['isDialogClosed'] = false
    this.setState(state)
  }

  onCloseDialog() {
    const state = Object.assign({}, this.state)
    state['isDialogClosed'] = true
    this.setState(state)
  }

  render() {
    return (
      <div className={`DeleteIcon ${this.props.className || ''}`}>
        {(() => {
          return !this.state.isDialogClosed ? (
            <div className="DeleteDialog">
              <p>削除しますか？</p>
              <p>Do you want to delete?</p>
              <div className="DeleteDialog__Buttons">
                <Button className="DeleteDialog__Cancel" type="dark" size="lg" onClick={() => this.onCloseDialog()}>
                  いいえ No
                </Button>
                <Button className="DeleteDialog__Delete" type="danger" size="lg" onClick={e => this.props.onClick(e)}>
                  削除 Delete
                </Button>
              </div>
            </div>
          ) : null
        })()}
        <Icon className="DeleteButton__Icon" type="trash" onClick={() => this.onShowDialog()} />
      </div>
    )
  }
}

export default DeleteIcon
